// extracted by mini-css-extract-plugin
module.exports = {"positionsBlock":"PositionsList_positionsBlock__3arXZ","cycle":"PositionsList_cycle__Se6n8"};